import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import IconBox from '../../Presale/IconBox'



const Banner = () => {


    return (
        <>
            <section className='presale_banner py-lg-5 py-md-5 pb-0'>
                {/* <div className='bg_presale'>
                    <img src='assets/images/presale/presaleback.png' width={`100%`} />
                </div> */}
                <Container>
                    <Row className='justify-content-center' >
                        <Col lg={11} className='text-center'>
                            <div className="banner-content">
                                <h1 className="text-uppercase mb-3">
                                    <span className="text-wrapper">Empowering Your Investment Journey</span>
                                </h1>
                                <p className='text-primary'>At INFI, our presale is more than just an early investment opportunity; it's a gateway to becoming a part of a groundbreaking financial movement. We understand that stepping into the world of cryptocurrency can be daunting. That's why we've designed our presale to be not just accessible, but advantageous for our early adopters.</p>
                                <IconBox />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Banner
